import CursorIcon from '@assets/images/icons/collaboration-cursor.svg?react'
import { useCollaboratorsState } from '@components/ArtBoard/Collaboration/hooks/useCollaboratorsState'
import type { Collaborator } from '@components/ArtBoard/Collaboration/types'
import type { AppState } from '@store/types'
import clsJoin from 'classnames'
import { useRef } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { useCursorTracking } from './hooks'
import css from './styles.module.scss'

export const CollaborationPointers = () => {
  const scale = useSelector<AppState, number>(
    ({ canvas }) => canvas.scale,
    shallowEqual
  )

  const containerRef = useRef<HTMLDivElement>(null)

  useCursorTracking(containerRef)

  const collaborators = useCollaboratorsState()

  const getCursorColorVar = (collaborator: Collaborator) =>
    `var(--color-code-${collaborator.color})`

  const getTransformPositionStyle = (collaborator: Collaborator) =>
    `translate(${collaborator.offset.x}px, ${collaborator.offset.y}px) scale(${1 / scale})`

  return (
    <div className={css.collaboration_pointers} ref={containerRef}>
      {collaborators.map((collaborator) => (
        <div
          key={collaborator.id}
          className={clsJoin(css.item, css[collaborator.status])}
          style={{
            color: getCursorColorVar(collaborator),
            transform: getTransformPositionStyle(collaborator),
          }}
        >
          <CursorIcon className={css.cursor} />
          <div
            className={css.label}
            style={{ backgroundColor: getCursorColorVar(collaborator) }}
          >
            {collaborator.firstName}
          </div>
        </div>
      ))}
    </div>
  )
}
